import React, { createContext, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { paymentService } from '../services/paymentService';

const StripeContext = createContext();

const stripePromise = loadStripe(import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeProvider = ({ children }) => {
  const stripeOptions = {
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#0570de',
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#df1b41',
        fontFamily: 'Inter, system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      }
    }
  };

  const createCheckoutSession = async (priceId, userId) => {
    const data = await paymentService?.createCheckoutSession(priceId, userId);
    
    if (data?.url) {
      window.location.href = data?.url;
    }
    
    return data;
  };

  return (
    <StripeContext.Provider value={{ stripePromise, stripeOptions, createCheckoutSession }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripeContext = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripeContext must be used within a StripeProvider');
  }
  return context;
};

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
};

export default StripeProvider;